<div class="dialog-box card">
  <div class="card-header">
    Sub Biller
    <span class="float-end" (click)="onCloseDialogue()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>

  <div class="mb-3">
    @if (selectedSubBiller?.id) {
      <div class="py-4">
        <div class="d-flex align-items-center gap-4 justify-content-center">
          <span>
            {{ selectedSubBiller?.company_name }}
          </span>
          <span (click)="selectedSubBiller = {}; editField()">
            <i class="fa-solid fa-pen-to-square fs-5"></i>
          </span>
          <span (click)="onCloseDialogue('remove')"
            ><i class="fa-solid fa-circle-minus text-danger fs-5"></i
          ></span>
        </div>
      </div>
    } @else {
      <gtapp-auto-complete
        [data]="subBillerListData"
        placeHolder="Sub Biller"
        searchKeyword="company_name"
        inputId="subBillerLookupFieldId"
        [itemTemplate]="subBillerLookupTemplate"
        [initialValue]="subBillerStringValue"
        [addInitialKey]="!!subBillerStringValue.length"
        (inputChanged)="onSubBillerLookup($event)"
        (selected)="onSelectSubBiller($event)"
        [enableCloseOption]="true"
        (fieldCleared)="editField()"
      >
      </gtapp-auto-complete>
      <ng-template #subBillerLookupTemplate let-item>
        @if (item?.key === 0) {
          <div>Add Sub Biller</div>
        } @else {
          <div>
            {{ item.company_name }}
          </div>
        }
      </ng-template>
    }
  </div>
</div>
